import { makeRule } from '@core/utils/rule.js'

export let searchRules = {
  id: [
    {...makeRule('请输入正确的banner管理ID', 'integer', 'blur', false), min: 1},
  ],
}

export let formRules = {
  name: [
    {...makeRule('请输入banner管理名称', 'string')},
    {...makeRule('请输入至少2个字符', 'string'), min: 2},
  ],
  app_types: [
    {
      type: 'array',
      required: true,
      min: 1,
      message: '请选择上架APP',
      trigger: 'change',
    },
  ],
}



// WEBPACK FOOTER //
// ./src/views/app-banner/app-banner.rules.js